<p class="main-question">
  <strong>Crea tu cuenta</strong>
</p>
<p class="subtext">Ingresa tus datos para registrarte</p>
<br />
<form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-wrapper">
  <!-- Email -->
  <div class="field-group">
    <input
      type="email"
      formControlName="email"
      placeholder="Correo electrónico"
      autocomplete="email"
      [class.input-error]="hasFieldError('email')"
      (keydown)="preventSpaces($event)"
      (paste)="onPasteNoSpaces($event, 'email')"
    />
    <span class="field-error" *ngIf="hasFieldError('email')">
      {{ getFieldError('email') }}
    </span>
  </div>

  <!-- Usuario Aguacate: la identidad publica con la que invita.
       Se muestra siempre. Con el programa de invitados apagado es opcional,
       porque no se puede frenar un alta por un campo que todavia no paga. -->
  <div class="field-group">
    <input
      type="text"
      formControlName="llave"
      [placeholder]="
        referidosActivo
          ? 'Tu usuario de Aguacate (8 a 10 letras y números)'
          : 'Tu usuario de Aguacate (opcional, 8 a 10 letras y números)'
      "
      autocomplete="off"
      maxlength="10"
      [class.input-error]="hasFieldError('llave') || llaveEstado === 'tomada'"
      (input)="onLlaveInput()"
      (keydown)="preventSpaces($event)"
    />

    <span class="llave-hint" *ngIf="llaveEstado === 'libre'">
      {{ llavePreview }} esta disponible
    </span>
    <span class="llave-hint checking" *ngIf="llaveEstado === 'verificando'">
      Verificando {{ llavePreview }}…
    </span>
    <span class="field-error" *ngIf="llaveEstado === 'tomada'">
      {{ llaveMensaje }}
    </span>
    <span class="field-error" *ngIf="llaveEstado !== 'tomada' && llaveMensaje">
      {{ llaveMensaje }}
    </span>
    <span class="llave-help" *ngIf="!llaveMensaje && llaveEstado !== 'libre'">
      <!-- Neutro a propósito: en este paso todavía no se sabe el documento, y
           la campaña de referidos es por país. «Vas a invitar» le prometía el
           programa a quien quizá no le toca. -->
      <span *ngIf="referidosActivo">
        Es tu identidad en Aguacate. Sólo letras y números, sin tildes ni ñ.
      </span>
      <span *ngIf="!referidosActivo">
        Es tu identidad en Aguacate. Puedes elegirlo ahora o después desde la app.
        Sólo letras y números, sin tildes ni ñ.
      </span>
    </span>
  </div>

  <!-- Password -->
  <div class="field-group">
    <div class="password-input-wrapper">
      <input
        [type]="showPassword ? 'text' : 'password'"
        formControlName="password"
        placeholder="Crear contraseña"
        autocomplete="new-password"
        [class.input-error]="hasFieldError('password')"
        [class.input-valid]="isPasswordComplete"
        (keydown)="preventSpaces($event)"
        (paste)="preventPaste($event)"
      />
      <div class="field-icons">
        <mat-icon
          class="valid-icon"
          *ngIf="isPasswordComplete"
          aria-label="Contraseña válida"
          >check_circle</mat-icon
        >
        <button
          type="button"
          class="toggle-password"
          [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
          (click)="showPassword = !showPassword"
        >
          <mat-icon class="icon-color">{{
            showPassword ? "visibility_off" : "visibility"
          }}</mat-icon>
        </button>
      </div>
    </div>
    <span class="field-error" *ngIf="hasFieldError('password')">
      {{ getFieldError('password') }}
    </span>

    <!-- Requisitos en vivo: se marcan en verde a medida que se cumplen -->
    <app-password-rules-checklist
      [value]="passwordValue"
    ></app-password-rules-checklist>
  </div>

  <!-- Repeat Password -->
  <div class="field-group">
    <div class="password-input-wrapper">
      <input
        [type]="showRepeatPassword ? 'text' : 'password'"
        formControlName="repeatPassword"
        placeholder="Repetir contraseña"
        autocomplete="new-password"
        [class.input-error]="hasFieldError('repeatPassword')"
        [class.input-valid]="passwordsMatch"
        (keydown)="preventSpaces($event)"
        (paste)="preventPaste($event)"
      />
      <div class="field-icons">
        <mat-icon
          class="valid-icon"
          *ngIf="passwordsMatch"
          aria-label="Las contraseñas coinciden"
          >check_circle</mat-icon
        >
        <button
          type="button"
          class="toggle-password"
          [attr.aria-label]="showRepeatPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
          (click)="showRepeatPassword = !showRepeatPassword"
        >
          <mat-icon class="icon-color">{{
            showRepeatPassword ? "visibility_off" : "visibility"
          }}</mat-icon>
        </button>
      </div>
    </div>
    <span class="field-error" *ngIf="hasFieldError('repeatPassword')">
      {{ getFieldError('repeatPassword') }}
    </span>
  </div>

  <!-- Phone -->
  <div class="field-group">
    <div class="phone-group">
      <div class="custom-select" (click)="toggleDropdown()">
        <img *ngIf="selectedFlag" [src]="selectedFlag" alt="Bandera" />
        <span>{{ selectedCode }}</span>
      </div>

      <div *ngIf="showDropdown" class="custom-dropdown">
        <div
          class="option"
          *ngFor="let country of countryPhoneOptions; trackBy: trackByCode"
          (click)="selectPhone(country)"
        >
          <img [src]="'assets/flags/' + country.flag" [alt]="country.name" />
          <span>{{ country.code }} {{ country.name }}</span>
        </div>
      </div>

      <input
        type="tel"
        formControlName="phone"
        maxlength="30"
        [placeholder]="phonePlaceholder"
        autocomplete="tel"
        [class.input-error]="hasFieldError('phone')"
        (input)="onPhoneInput($event)"
        (paste)="onPhonePaste($event)"
        (blur)="onPhoneBlur()"
      />
    </div>
    <span class="field-error" *ngIf="hasFieldError('phone')">
      {{ getFieldError('phone') }}
    </span>
    <span class="phone-hint" *ngIf="!hasFieldError('phone')">
      {{ phoneHint }}
    </span>
  </div>

  <!-- Terms checkbox -->
  <label class="checkbox-label">
    <input type="checkbox" formControlName="termsAccepted" />
    <span>
      Acepto los <a href="#">términos y condiciones</a> y la política de
      privacidad.
    </span>
  </label>

  <!-- Marketing checkbox -->
  <label class="checkbox-label">
    <input type="checkbox" formControlName="marketingAccepted" />
    <span>
      Autorizo el uso de mi información para recibir promociones.
    </span>
  </label>

  <!-- VPN Warning -->
  <div class="warning-box">
    <mat-icon class="warning-icon">warning</mat-icon>
    <span class="warning-text">
      Recomendamos no utilizar VPN durante el registro para evitar problemas de validación.
    </span>
  </div>

  <!-- Buttons -->
  <button type="submit" [disabled]="!isFormValid || isSubmitting">
    {{ isSubmitting ? 'Registrando...' : 'Continuar' }}
  </button>
  <button type="button" class="back-btn" (click)="goBack()" [disabled]="isSubmitting">Volver</button>
</form>
